import React from "react";
import { AiFillCode } from "react-icons/ai";
import {
  BsDiscord,
  BsGithub,
  BsInstagram,
  BsLinkedin,
  BsTwitter,
} from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://www.linkedin.com/in/ramit-sarkar-bb26581ba/">
        {" "}
        <BsLinkedin />
      </a>
    </div>
    <div className="app__social">
      <a href="https://leetcode.com/the_imperfect_guy/">
        {" "}
        <AiFillCode />
      </a>
    </div>
    <div>
      <a href="https://github.com/ramitsarkar902">
        <BsGithub />
      </a>
    </div>
    <div>
      <a href="https://discord.gg/rEZWFaF54s">
        <BsDiscord />
      </a>
    </div>
  </div>
);

export default SocialMedia;
